export default "__VITE_ASSET__Bfbq8_C7__"